import "./PartnersSection.css";
import { PartnersMarquee } from "@tennr/frontend/sections/PartnersMarquee";

import { Heading } from "@tennr/frontend/components/Heading";
import { FC } from "react";

export const PartnersSection: FC = () => {
  return (
    <section className="partners section-y">
      <Heading
        title="WHO WE WORK WITH"
        heading="Trusted nationwide"
        body="From national networks to independent providers, we power high performing operations and over 10m documents per month."
        color="dark"
        variant="section"
        width={460}
      />
      <div className="cards-container">
        <PartnersMarquee />
      </div>
    </section>
  );
};
